import { RouterModule } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { NgModule } from '@angular/core';
import { FormComponent } from './form/form.component';
import { EndComponent } from './end/end.component';
import { FormioModule } from '@formio/angular';
import { RecaptchaModule } from 'ng-recaptcha';
import { ContainerComponent } from './container/container.component';
import { CommonModule } from '@angular/common';
import { ModelModule } from '../model/model.module';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import {SharedDirectivesModule} from "../../shared/directives.module";
import {ComponentsModule} from "../components/components.module";
import {HomeComponent} from "./home/home.component";
import {PanelModule} from "primeng/panel";

@NgModule({
  declarations: [
    ContainerComponent,
    HomeComponent,
    FormComponent,
    EndComponent,
  ],
  imports: [
    CommonModule,
    FormioModule,
    RecaptchaModule,
    ConfirmDialogModule,
    RouterModule,
    ModelModule,
    ComponentsModule,
    FormsModule,
    ButtonModule,
    MessagesModule,
    SharedDirectivesModule,
    PanelModule
  ],
  exports: [
    ContainerComponent,
    HomeComponent,
    FormComponent,
    EndComponent,
  ],
})
export class PagesModule {}
